// Class names (009 revision 6, FR-044): `cn` joins classes with `clsx` and resolves conflicts with `tailwind-merge`, told
// about the spacing system's own names (`h-control`, `px-gutter`, `max-w-reading`, the table density), so a caller's
// `className` replaces a component's default of the same kind instead of both applying. It replaces `cx`.
import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/** The spacing system's named sizes (system.css), beyond the numeric steps tailwind-merge already knows. */
const spacing = [
  'control',
  'control-sm',
  'control-touch',
  'table-head',
  'table-row',
  'table-row-compact',
  'table-cell-x',
  'table-cell-y',
  'gutter',
];

const merge = extendTailwindMerge({
  extend: {
    theme: {
      spacing,
      container: ['content', 'reading', 'phone'],
      radius: ['staff-card', 'staff-tile', 'staff-control', 'card', 'field', 'button', 'pill'],
    },
    // `border-thick` (styles.css) is a width; without this it would be read as a colour and dropped by one.
    classGroups: { 'border-w': [{ border: ['thick'] }] },
  },
});

/**
 * Joins class names; a later class of the same kind replaces an earlier one (`cn('px-4', 'px-6')` is `px-6`).
 * @param inputs class names, lists, objects of flags or falsy values
 * @returns the space-separated classes
 */
export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs));
}
